

















import Vue from 'vue'
export default Vue.extend({
	props: ['icon', 'text', 'onlyIcon', 'clickable', 'disabled', 'isMobile']
})
